import { StateKey } from 'common/utils/flipState'
import { CommonState } from 'common/types'

export const TRANSLATE_Y = 800
export const DETAIL_HEIGHT = 188
export const SORT_LIST_HEIGHT = 48

export interface MapListState {
  translateY: number
}

const initialState: MapListState = {
  translateY: TRANSLATE_Y,
}

const INIT = 'map/list/INIT'
const SET = 'map/list/SET'

export const initMapList = (curState: StateKey) => {
  return {
    curState,
    type: INIT,
  }
}

export const setMapList = (curState: StateKey, translateY: number) => (dispatch, getState: () => CommonState) => {
  const mapList = getState().mapList[curState]
  if (mapList.translateY === translateY) return
  dispatch({
    translateY,
    curState,
    type: SET,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return { ...initialState }
    case SET:
      return {
        ...state,
        translateY: action.translateY,
      }
    default:
      return state
  }
}

export default reducer
